/**
 * Legal documents for the portals.
 *
 * Structure follows realm's `world-ui/features/system/legalContent.tsx` so the
 * two read as one company's documents. Two deliberate differences:
 *
 *   1. GameCodex is the operating entity DIRECTLY. Realm's terms say "operated
 *      by GameCodex on behalf of the {world} publisher" because each world has
 *      its own publisher; the portals have none.
 *   2. The privacy policy is real. Realm's is a placeholder stub, and it should
 *      not be shipped as-is anywhere.
 *
 * ⚠️ These are drafted, not reviewed. They describe what the software actually
 * does, which is the part engineering can be accountable for — a lawyer should
 * read them before any portal takes money or launches publicly.
 */

export interface LegalSection {
  heading?: string
  body: string[]
}

export interface LegalDoc {
  title: string
  /** Human-readable last-updated date, shown under the title. */
  updated?: string
  intro?: string[]
  sections?: LegalSection[]
  /** Simple paragraph body for docs that don't need sections. */
  body?: string | string[]
}

/** Substitute `{portal}` (the in-world brand) and `{entity}` (the operator). */
export function fillPortal(text: string, portal: string, entity = 'GameCodex'): string {
  return text.replace(/\{portal\}/g, portal).replace(/\{entity\}/g, entity)
}
